<template lang="pug">
#app(:class="{ 'category-nav': showCategoryNav, 'nav-hidden': navHidden }")
  site-nav(v-if="!navHidden")
  
  site-auth
  
  category-nav(v-if="showCategoryNav" :mobile="true")

  .page-width.full-height
    el-container
      el-aside.hide-sm-and-down(width="280px" v-if="showCategoryNav")
        category-nav(v-if="showCategoryNav")
      el-main
        router-view
      //- el-aside.hide-sm-and-down(width="280px" v-if="showFeedActions")
        side-nav

  site-footer
</template>

<script>
// Nav
import SiteNav from "./components/SiteNav.vue";
import SiteAuth from "./components/SiteAuth.vue";
import CategoryNav from "./components/CategoryNav.vue";
import SideNav from "./components/SideNav.vue";

// Footer
import SiteFooter from "./components/SiteFooter.vue";

export default {
  name: "app",
  components: {
    SiteNav,
    SiteAuth,
    CategoryNav,
    SideNav,
    SiteFooter
  },
  computed: {
    navHidden() {
      return this.$route.query.hideNav;
    },
    showCategoryNav() {
      return ["explore", "feed"].indexOf(this.$route.name) !== -1;
    },
    showFeedActions() {
      return ["feed"].indexOf(this.$route.name) !== -1;
    },
    showPostActions() {
      return ["post"].indexOf(this.$route.name) !== -1;
    }
  }
};
</script>

<style lang="stylus">
$nav-height = 70px;
$category-nav-height = 50px;

html, body {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}

#app {
  color: #2c3e50;
  min-height: 600px;
  text-align: center;
  padding-top: $nav-height;

  &.nav-hidden {
    padding-top: 0 !important;

    &.category-nav {
      +tablet() {
        padding-top: $category-nav-height !important;
      }
    }
  }

  &.category-nav {
    +tablet() {
      padding-top: $nav-height + $category-nav-height;
    }
  }
}

.page-width {
  margin: 0 auto;
  max-width: $page-width;
  width: 100%;
}

.full-height {
  min-height: 100vh;
}

.post-actions {
  padding: 20px 20px 0px 20px;

  .el-button {
    display: block;
    margin: 0 10px 0 0 !important;
  }
}

.el-main {
  +mobile() {
    padding: 20px 0 !important;
    c;
    padding: 0 !important;
    c;
  }
}

.hide-xs-only {
  display: block !important;

  +mobile() {
    display: none !important;
  }
}

.hide-sm-and-down {
  display: block !important;

  +tablet() {
    display: none !important;
  }
}

.hide-sm-and-up {
  display: block !important;

  +tabletup() {
    display: none !important;
  }
}

.hide-md-and-up {
  display: block !important;

  +laptopup() {
    display: none !important;
  }
}
</style>
